import Container from '@/projectRoot/src/components/common/general/container/Container';
import style from './headerSubmenu.module.scss';
import { chunkArray } from '@/projectRoot/src/utils/handlers/miscHandler';
import LinkUrl from '@/projectRoot/src/components/common/general/link/LinkUrl';
import Heart from '@/projectRoot/src/components/common/svg/Heart';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';
import CubesImage from '@/projectRoot/src/components/common/general/cubes-image/CubesImage';
import Image from 'next/image';

interface Props {
    item: MenuItemDto;
    classes?: string[];
}

const HeaderSubmenu = ({item, classes = []}: Props) => {

     const {isMobileView} = useGlobals();
  return (
    <div className={`${style.submenu} ${classes.join(' ')}`}>
        <Container classes={[style.wrapper]}>
            <div className={`${style.submenuItems} ${style['number_' + chunkArray(item.children, 6).length]}`}>
                {chunkArray(item.children, 6).map((el, index) => {return (
                    <div className={style.submenuPart} key={index}>
                        {
                            el.map((el2, index) => {
                                return (
                                    <LinkUrl 
                                        key={index}
                                        text={el2.title}
                                        url={el2.url}
                                        classes={[style.submenuItem]}
                                    />
                                )
                            })
                        }
                    </div>
                )})}
            </div>
            {
                (item.promo1 || item.promo2 || item.promo3) && (!isMobileView ? chunkArray(item.children, 6).length < 5 : true)
                ?
                <div className={`${style.promoItems} ${style['number_' + chunkArray(item.children, 6).length]}`}>
                    {
                        item.promo1
                        ?
                        <div className={style.promoItem}>
                            <figure className={style.backgroundImage}>
                                <CubesImage imageNarrow={item.promo1.image_narrow_url} alt={item.promo1.title} />
                            </figure>
                            <div className={style.promoItemContent}>
                                <p className={style.title}>
                                    {item.promo1.title}
                                </p>
                                {
                                    item.promo1.description
                                    ?
                                    <p className={style.description}>
                                        {item.promo1.description}
                                    </p>
                                    : <></>
                                }
                                <LinkUrl 
                                    text={item.promo1.call_to_action_text}
                                    url={item.promo1.call_to_action_url}
                                    classes={[style.link]}
                                />
                            </div>
                        </div>
                        : <></>
                    }
                    {
                        item.promo2 && (!isMobileView && chunkArray(item.children, 6).length < 4)
                        ?
                        <div className={style.promoItem} style={{backgroundImage: `url("${item.promo2.image_narrow_url}")`}}>
                            <div className={style.promoItemContent}>
                                <p className={style.title}>
                                    {item.promo2.title}
                                </p>
                                {
                                    item.promo2.description
                                    ?
                                    <p className={style.description}>
                                        {item.promo2.description}
                                    </p>
                                    : <></>
                                }
                                <LinkUrl 
                                    text={item.promo2.call_to_action_text}
                                    url={item.promo2.call_to_action_url}
                                    classes={[style.link]}
                                />
                            </div>
                        </div>
                        : <></>
                    }
                    {
                        item.promo3 && (!isMobileView && chunkArray(item.children, 6).length < 3)
                        ?
                        <div className={style.promoItem} style={{backgroundImage: `url("${item.promo3.image_narrow_url}"), linear-gradient(
                        180deg,
                        rgba(0, 0, 0, 0) 50%,
                        rgba(0, 0, 0, 0.6)
                        )`}}>
                            <div className={style.promoItemContent}>
                                <p className={style.title}>
                                    {item.promo3.title}
                                </p>
                                {
                                    item.promo3.description
                                    ?
                                    <p className={style.description}>
                                        {item.promo3.description}
                                    </p>
                                    : <></>
                                }
                                <LinkUrl 
                                    text={item.promo3.call_to_action_text}
                                    url={item.promo3.call_to_action_url}
                                    classes={[style.link]}
                                />
                            </div>
                        </div>
                        : <></>
                    }
                </div>
                : <></>
            }
            {
                item.call_to_action_url && item.call_to_action_text
                ?
                <LinkUrl url={item.call_to_action_url} text={item.call_to_action_text} classes={[style.menuItemLink]} />
                : <></>
            }
        </Container>
    </div>
  )
};

export default HeaderSubmenu;
